import { fontSize } from "../typography";

// Dividing lines in tables should gray[20], that should be the primary there
// We need to simultaneously change typography and table, since they're too inexorably tied together

// SKIM to do: Data text needs to be 12px

export const MuiTableCell = {
  styleOverrides: {
    root: {
      fontSize: fontSize.base,
      paddingTop: 1.5,
      paddingBottom: 1.5,
    },
  },
};
